const CartLargeIcon: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            width="24"
            height="24"
            fill="#FFFFFF"
            data-name="Layer 1"
            viewBox="0 0 24 24"
        >
            <path d="M12.2 9h1.6V6.8H16V5.2h-2.2V3h-1.6v2.2H10v1.6h2.2ZM20 5v5.5L7.45 12.72 5 3H1.25a1 1 0 0 0 0 2h2.22L6.7 18H20v-2H8.26l-.33-1.33L22 12.18V5ZM7 19a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 7 19m12 0a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 19 19"></path>
        </svg>
    )
}
export default CartLargeIcon;